import { useCallback, useState } from "react";

/**
 * Type for available side panels
 */
export type SIDE_PANELS_AVAILABLE =
  | "COMMENTS"
  | "REVISIONS"
  | "RECOMMENDATIONS";

/**
 * Hook for managing side panel state and the active question
 */
export const useSidePanelState = () => {
  const [sidePanelOpen, setSidePanelOpen] =
    useState<SIDE_PANELS_AVAILABLE | null>(null);
  const [activeCommentQuestion, setActiveCommentQuestion] = useState<
    string | null
  >(null);

  const openSidePanel = useCallback(
    (panelName: SIDE_PANELS_AVAILABLE, questionId: string) => {
      setSidePanelOpen(panelName);
      setActiveCommentQuestion(questionId);
    },
    [],
  );

  const closeSidePanel = useCallback(() => {
    setSidePanelOpen(null);
    setActiveCommentQuestion(null);
  }, []);

  return {
    sidePanelOpen,
    activeCommentQuestion,
    openSidePanel,
    closeSidePanel,
    setActiveCommentQuestion,
  };
};
